@import './fluid-badge.theme.less';

// ================================================================ //
// -- Theme Definition

:host {
  display: inline-block;
  vertical-align: middle;
  max-width: 100%;

  *, ::after, ::before {
    box-sizing: border-box;
  }

  .fluid-badge {
    /**
     * LEGACY THEME
     */
    &.legacy {
      @import '../../styles/variables-iuw-legacy.less';
      @badge-tokens: @badge-tokens-legacy;
      @badge();
    }

    /**
     * LIBERTY MUTUAL THEME
     */
    &.lm {
      @import '../../styles/variables-lm.less';
      @badge-tokens: @badge-tokens-lm;
      @badge();
    }

    /**
     * LM CORPORATE THEME
     */
    &.corp, &.default {
      @import '../../styles/variables-lm-corp.less';
      @badge-tokens: @badge-tokens-corp;
      @badge();
    }

    /**
     * LM CORPORATE THEME
     */
    &.portal {
      @import '../../styles/variables-lm-portal.less';
      @badge-tokens: @badge-tokens-portal;
      @badge();
    }
  }

  // == Block Layout

  &(.badge-layout-block) {
    display: block;
  }
}


// ================================================================ //
// -- Component Detached Ruleset

@badge: {
  @label: @badge-tokens[@label];
  @icon-margin: @badge-tokens[@icon-margin];
  @chip: @badge-tokens[@chip];
  @chip-label: @chip[@label];
  @indicator: @badge-tokens[@indicator];
  @indicator-label: @indicator[@label];

  height: @badge-tokens[height];
  vertical-align: middle;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: @font-family;
  font-size: @badge-tokens[font-size];
  font-weight: @font-weight-bold;
  text-align: center;
  padding-left: @badge-tokens[padding-left];
  padding-right: @badge-tokens[padding-right];
  border-width: 2px;
  border-style: @border-style;
  border-radius: 4px;

  // ==== Colors

  .create-badge-color-profiles();

  // ==== Style: Chip

  &.badge-style-chip {
    height: @chip[height];
    padding-left: @chip[padding-left];
    padding-right: @chip[padding-right];
    border-radius: @chip[border-radius];

    .badge-label {
      font-size: @chip-label[font-size];
    }
  }

  // ==== Style: Indicator

  &.badge-style-indicator {
    min-width: @indicator[height];
    height: @indicator[height];
    border-radius: @indicator[border-radius];
    line-height: 1;
    padding-left: @indicator[padding-left];
    padding-right: @indicator[padding-right];

    .badge-label {
      font-size: @indicator-label[font-size];
      line-height: 1;
      letter-spacing: 0;
    }

    &.badge-color-solid {
      border-width: 0;
    }
  }

  // ==== Label

  .badge-label {
    max-width: 100%;
    font-size: @label[font-size];
    line-height: @label[line-height];
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: clip;
    pointer-events: none;
  }

  // ==== Icon Container

  .badge-icon-before,
  .badge-icon-after {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .badge-icon-before ~ .badge-label {
    margin-left: @icon-margin;
  }

  .badge-label ~ .badge-icon-after {
    margin-left: @icon-margin;
  }
};


// ================================================================ //
// -- Mixins

// ==== Color Profiles

.create-badge-color-profiles() {
  @color-profiles: @badge-tokens[@map--color-profiles];

  each(@color-profiles, {
    @profile: @value; // @value = current object from loop iteration
    @name: @profile[@name];

    &.badge-color-@{name} {
      background-color: rgba(@profile[@profile-color], .08);
      border-color: @profile[@profile-color];
      color: @profile[@text-color];

      .badge-icon-before,
      .badge-icon-after {
        color: @profile[@icon-color]; // Sets FLUID Icon "fill" color
        fill: currentColor; // Sets non-FLUID icon "fill" color
      }

      &.badge-color-solid {
        background-color: @profile[@solid-profile-color];
        border-color: @profile[@solid-profile-color];
        color: @profile[@solid-text-color];

        .badge-icon-before,
        .badge-icon-after {
          color: inherit; // Sets FLUID Icon "fill" color
          fill: currentColor; // Sets non-FLUID icon "fill" color
        }
      }
    }
  });
};
